var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8354 15.4048H14.4956C14.579 15.4048 14.6672 15.4328 14.7319 15.4927H14.7329L16.1011 16.5288V15.7925C16.1011 15.6112 16.251 15.4292 16.4644 15.4292H17.1812V11.355H11.8354V15.4048ZM6.79541 13.7729H7.51221C7.69348 13.773 7.87549 13.9229 7.87549 14.1362V14.8726L9.24268 13.8364L9.24658 13.8335L9.35596 13.7729C9.39316 13.758 9.43258 13.7495 9.47998 13.7495H11.1089V11.1597C11.1091 10.8546 11.3585 10.6052 11.6636 10.605H15.4526V7.10693H6.79541V13.7729ZM17.9546 15.6245C17.9544 15.9298 17.7052 16.1792 17.3999 16.1792H16.8755V17.2798C16.8755 17.4321 16.7832 17.552 16.6655 17.6108C16.5995 17.6439 16.5339 17.6431 16.4878 17.6431C16.4044 17.643 16.3161 17.616 16.2515 17.5562L14.3745 16.1548H11.688C11.3826 16.1548 11.1333 15.9055 11.1333 15.6001V14.4751H9.64893L7.77295 15.8765L7.77002 15.8784C7.69428 15.9289 7.63019 15.9634 7.53564 15.9634C7.50111 15.9634 7.45595 15.9633 7.40771 15.9497L7.35889 15.9312C7.2412 15.8723 7.14893 15.7524 7.14893 15.6001V14.4995H6.62451C6.31909 14.4995 6.06885 14.2493 6.06885 13.9438V6.9126C6.06885 6.60718 6.31909 6.35693 6.62451 6.35693H15.6724C15.9776 6.35711 16.2271 6.60728 16.2271 6.9126V10.605H17.3765C17.6828 10.6052 17.9274 10.8552 17.9546 11.1538L17.9556 11.1597H17.9546V15.6245Z",
    fill: "currentColor",
    stroke: "#252B37",
    strokeWidth: 0.15
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMails);
export default __webpack_public_path__ + "static/media/mails.35324dab93577334af233a8f877a0d47.svg";
export { ForwardRef as ReactComponent };